/* eslint-disable indent */
/* eslint-disable unicorn/prefer-module */
/* eslint-disable no-console */
import { useState, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import toast from "react-hot-toast";
import { FaBan, FaEdit, FaKey, FaTrash, FaUndo } from "react-icons/fa";
import { FiSave } from "react-icons/fi";
import { ListaEdificios } from "../../components";
import { AgenciasDropdown, matchAgenciaFilter } from "../../components/AgenciasDropdown";
import { Header } from "../../components/Header";
import { isAdmin } from "../../constants/permisos";
import { ROLES } from "../../constants/roles";
import { useAuthContext } from "../../context/auth";
import {
  getEdificios,
  saveUsuario,
  getUsers,
  getIntermediarios,
  updateUsuario,
  deleteUsuario,
  setUsuarioHabilitado,
  getClientes,
} from "../../utils";
import { client as supabaseClient } from "../../utils/supabase";
import styles from "./stylesUsuarios.module.scss";

export const Usuarios = () => {
  const [, setEdificios] = useState([]);
  const methods = useForm();
  const [usuarios, setUsuarios] = useState([]);
  const [sortColumn, setSortColumn] = useState("nombre");
  const [sortDirection, setSortDirection] = useState("asc");
  const [newUser, setNewUser] = useState({
    nombre: "",
    apellido: "",
    email: "",
    rol: "",
    edificiosOk: "",
    entidad: "",
    cargo: "",
  });
  const [showListaEdificios, setShowListaEdificios] = useState(false);
  const [intermediarios, setIntermediarios] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [clientes, setClientes] = useState([]);
  const [searchNombre, setSearchNombre] = useState("");
  const [searchApellido, setSearchApellido] = useState("");
  const [searchAgencia, setSearchAgencia] = useState("");
  const [searchCliente, setSearchCliente] = useState("");
  const [searchCargo, setSearchCargo] = useState("");
  const [searchCorreo, setSearchCorreo] = useState("");
  const [filtroRol, setFiltroRol] = useState("");
  const [selectedRoles, setSelectedRoles] = useState({
    agencia: true,
    cliente: true,
    edificio: true,
  });
  const [showModal, setShowModal] = useState(false);
  const [passwordModal, setPasswordModal] = useState({ show: false, usuario: null });
  const [passwordInput, setPasswordInput] = useState("");

  const { pais, rol, id: userId } = useAuthContext();
  const puedeVerTodosLosRoles = rol === ROLES.GERENCIA && isAdmin(userId);
  const puedeEditar = rol !== ROLES.INVERSOR;
  const esAdmin = isAdmin(userId);
  const puedeSetearPassword = [1, 4, 7, 9, 139].includes(Number(userId));

  const paisMap = {
    Chile: "CHI",
    Perú: "PER",
    Uruguay: "URU",
    Region: "REG",
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getEdificios({ pais: paisMap[pais] });
        if (data && Array.isArray(data) && data.length > 0) {
          setEdificios(data);
        } else {
          setEdificios([]);
        }
      } catch (error) {
        if (error.message === "No data found") {
          setEdificios([]);
        } else {
          console.error("Error al obtener edificios:", error);
          setEdificios([]);
          toast.error("Error al cargar edificios");
        }
      }

      try {
        const data = await getClientes({ pais });
        setClientes(data || []);
      } catch (error) {
        console.error("Error al obtener clientes:", error);
        setClientes([]);
      }
    };

    fetchData();
  }, [pais]);

  const fetchUsuarios = async () => {
    try {
      const newUsuarios = await getUsers({ includeDisabled: esAdmin });
      setUsuarios(newUsuarios);
    } catch (error) {
      console.error("Error al obtener usuarios:", error);
    }
  };

  useEffect(() => {
    fetchUsuarios();
    const fetchIntermediarios = async () => {
      try {
        const newIntermediarios = await getIntermediarios({ pais });
        setIntermediarios(newIntermediarios);
      } catch (error) {
        console.error("Error al obtener intermediarios:", error);
      }
    };
    fetchIntermediarios();
  }, [pais]);

  const handleEditClick = (usuario) => {
    setEditingUser({
      ...usuario,
      entidad:
        usuario.rol === "agencia" ? usuario.agencia || "" : usuario.rol === "cliente" ? usuario.cliente_id || "" : "",
      cargo: usuario.cargo || "",
      cargo_detalle: usuario.cargo_detalle || "",
      telefono: usuario.telefono || "",
      fecha_nacimiento: usuario.fecha_nacimiento || "",
    });
    setIsEditing(true);
  };

  const handleSaveClick = async () => {
    if (editingUser && editingUser.id) {
      const originalUser = usuarios.find((u) => u.id === editingUser.id);
      const isEmailChanged = originalUser && originalUser.email.toLowerCase() !== editingUser.email.toLowerCase();
      const paisCode = paisMap[pais] || "";

      let emailExists = false;
      if (isEmailChanged) {
        emailExists = usuarios.some(
          (usuario) =>
            usuario.email?.toLowerCase() === editingUser.email.toLowerCase() &&
            usuario.id !== editingUser.id &&
            usuario.pais === paisCode
        );
      }

      if (emailExists) {
        setEmailError("Este correo ya está registrado");
        toast.error("Este correo ya está registrado");
        return;
      }

      if ((editingUser.rol === "agencia" || editingUser.rol === "cliente") && !editingUser.cargo) {
        toast.error("Debe seleccionar un cargo");
        return;
      }

      try {
        const updatePayload = {
          id: editingUser.id,
          email: editingUser.email,
          agencia: editingUser.rol === "agencia" ? parseInt(editingUser.entidad, 10) : null,
          cliente_id: editingUser.rol === "cliente" ? parseInt(editingUser.entidad, 10) : null,
          cargo: editingUser.cargo,
          cargo_detalle: editingUser.cargo_detalle || null,
          telefono: editingUser.telefono,
          fecha_nacimiento: editingUser.fecha_nacimiento,
        };
        if (esAdmin) {
          updatePayload.nombre = editingUser.nombre;
          updatePayload.apellido = editingUser.apellido;
          updatePayload.rol = editingUser.rol;
        }
        const updatedUser = await updateUsuario(updatePayload);

        setUsuarios((prev) => prev.map((u) => (u.id === updatedUser.id ? updatedUser : u)));

        setEditingUser(null);
        setIsEditing(false);
        setEmailError("");
        toast.success("Usuario actualizado correctamente");
      } catch (error) {
        console.error("Error saving user:", error);
        toast.error("Error al guardar usuario");
      }
    }
  };

  const handleToggleHabilitado = async (usuario) => {
    const estaActivo = usuario.habilitado !== false;
    if (
      estaActivo &&
      !window.confirm("¿Anular el acceso de este usuario? No podrá iniciar sesión hasta reactivarlo.")
    ) {
      return;
    }
    try {
      const { error } = await setUsuarioHabilitado(usuario.id, !estaActivo);
      if (error) throw error;
      toast.success(estaActivo ? "Acceso anulado" : "Acceso reactivado");
      await fetchUsuarios();
    } catch (error) {
      console.error("Error al cambiar acceso del usuario:", error);
      toast.error("Error al cambiar el acceso");
    }
  };

  const handleDeleteClick = async (usuario) => {
    const confirmMsg = `¿Eliminar DEFINITIVAMENTE a ${usuario.nombre} ${usuario.apellido} (${usuario.email})? Esta acción borra el usuario de forma permanente y NO se puede deshacer. Para una baja reversible usá "Anular acceso".`;
    if (!window.confirm(confirmMsg)) return;

    const { data, error } = await deleteUsuario(usuario.id);

    if (error) {
      if (error.code === "23503") {
        toast.error(
          "No se puede eliminar: el usuario tiene registros asociados (ventas, cobros, contactos, etc.). Usá 'Anular acceso' para una baja reversible."
        );
      } else {
        toast.error("Error al eliminar usuario");
      }
      return; // no remover del estado: el borrado no se concretó
    }

    if (!data || data.length === 0) {
      // 0 filas afectadas (ej. RLS) → no se borró nada, mantener la fila
      toast.error("No se eliminó ningún usuario");
      return;
    }

    setUsuarios((prev) => prev.filter((u) => u.id !== usuario.id));
    toast.success("Usuario eliminado");
  };

  const handleSetPassword = (usuario) => {
    setPasswordInput("");
    setPasswordModal({ show: true, usuario });
  };

  const handleConfirmPassword = async () => {
    const { usuario } = passwordModal;
    if (!passwordInput || passwordInput.length < 6) {
      toast.error("La contraseña debe tener al menos 6 caracteres");
      return;
    }

    try {
      const { data, error } = await supabaseClient.functions.invoke("set-user-password", {
        body: { email: usuario.email, password: passwordInput },
      });

      if (error) {
        let serverMsg = "Error al asignar contraseña";
        try {
          const body = await error.context?.json?.();
          if (body?.error) serverMsg = body.error;
        } catch {
          // no body
        }
        toast.error(serverMsg);
        return;
      }

      const result = typeof data === "string" ? JSON.parse(data) : data;
      if (result.success) {
        toast.success("Contraseña asignada correctamente");
        setPasswordModal({ show: false, usuario: null });
      } else {
        toast.error(result.error || "Error al asignar contraseña");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error al asignar contraseña");
    }
  };

  const handleEmailChange = (e) => {
    if (editingUser) {
      setEditingUser({ ...editingUser, email: e.target.value });
    }
  };

  const handleEntidadChange = (e) => {
    if (editingUser) {
      setEditingUser({ ...editingUser, entidad: e.target.value });
    }
  };

  const handleCargoChange = (e) => {
    if (editingUser) {
      setEditingUser({ ...editingUser, cargo: e.target.value });
    }
  };

  const handleCargoDetalleChange = (e) => {
    if (editingUser) {
      setEditingUser({ ...editingUser, cargo_detalle: e.target.value });
    }
  };

  const handleSort = (column) => {
    setSortColumn(column);
    setSortDirection(sortColumn === column && sortDirection === "asc" ? "desc" : "asc");
  };

  const getEntidadNombre = (usuario) => {
    if (usuario.rol === "cliente") {
      const cliente = clientes.find((c) => c.id === usuario.cliente_id);
      return cliente
        ? cliente.empresa === cliente.producto
          ? cliente.nombre
          : `${cliente.empresa} | ${cliente.producto}`
        : "";
    }
    if (usuario.rol === "agencia") {
      return intermediarios.find((i) => i.id === usuario.agencia)?.nombre || "";
    }
    return "";
  };

  const sortedUsuarios = usuarios
    .filter((usuario) => {
      const paisCode = paisMap[pais] || "";
      const validPais = usuario.pais === paisCode;
      // Los suspendidos (habilitado === false) solo se muestran al admin [1,4];
      // para el resto se ocultan (defensivo, redundante con el getter).
      const isSuspendido = usuario.habilitado === false;
      if (isSuspendido && !esAdmin) return false;
      const isValid = validPais && usuario.email;
      if (!isValid) return false;
      if (rol === ROLES.INFRAESTRUCTURA && usuario.rol !== "edificio") return false;
      if (filtroRol && usuario.rol !== filtroRol) return false;

      const searchNombreLower = searchNombre.toLowerCase().trim();
      const searchApellidoLower = searchApellido.toLowerCase().trim();
      const searchCargoLower = searchCargo.toLowerCase().trim();
      const searchCorreoLower = searchCorreo.toLowerCase().trim();

      // Lógica de filtrado por agencia (usa matchAgenciaFilter)
      const agenciaMatch =
        !searchAgencia || (usuario.rol === "agencia" && matchAgenciaFilter(searchAgencia, usuario.agencia, pais));

      // Lógica de filtrado por cliente
      const clienteMatch = searchCliente
        ? usuario.rol === "cliente" && usuario.cliente_id?.toString() === searchCliente
        : true;

      return (
        (!searchNombreLower || usuario.nombre?.toLowerCase().includes(searchNombreLower)) &&
        (!searchApellidoLower || usuario.apellido?.toLowerCase().includes(searchApellidoLower)) &&
        agenciaMatch &&
        clienteMatch &&
        (!searchCargoLower || usuario.cargo?.toLowerCase() === searchCargoLower) &&
        (!searchCorreoLower || usuario.email?.toLowerCase().includes(searchCorreoLower))
      );
    })
    .sort((a, b) => {
      let valueA = a[sortColumn] || "";
      let valueB = b[sortColumn] || "";
      if (sortColumn === "agencia") {
        valueA = getEntidadNombre(a);
        valueB = getEntidadNombre(b);
      }
      return sortDirection === "asc"
        ? String(valueA).localeCompare(String(valueB), "es")
        : String(valueB).localeCompare(String(valueA), "es");
    });

  const formatTelefono = (value, paisUsuario) => {
    const digits = value.replace(/\D/g, "");
    const prefix = paisUsuario === "PER" ? "51" : "56";
    const prefixLen = prefix.length;
    let clean = digits;
    if (clean.startsWith(prefix)) clean = clean.slice(prefixLen);
    if (paisUsuario === "PER") {
      const p1 = clean.slice(0, 3);
      const p2 = clean.slice(3, 6);
      const p3 = clean.slice(6, 9);
      return `+${prefix} ${p1}${p2 ? " " + p2 : ""}${p3 ? " " + p3 : ""}`.trim();
    }
    if (clean.startsWith("9")) clean = clean.slice(1);
    const p1 = clean.slice(0, 4);
    const p2 = clean.slice(4, 8);
    return `+${prefix} 9 ${p1}${p2 ? " " + p2 : ""}`.trim();
  };

  const handleTelefonoChange = (e) => {
    if (!editingUser) return;
    const raw = e.target.value;
    const paisCode = editingUser.pais || paisMap[pais] || "";
    const formatted = raw ? formatTelefono(raw, paisCode) : "";
    setEditingUser({ ...editingUser, telefono: formatted });
  };

  const capitalizeFirstLetter = (str) => {
    if (!str) return str;
    return str
      .split(" ")
      .map((word) => (word.length > 0 ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : word))
      .join(" ");
  };

  const getEntidadOptions = () => {
    if (newUser.rol === "agencia") {
      return intermediarios.map((intermediario) => ({
        value: intermediario.id,
        label: intermediario.nombre,
      }));
    }
    if (newUser.rol === "cliente") {
      return clientes.map((cliente) => ({
        value: cliente.id,
        label: cliente.nombre,
      }));
    }
    return [];
  };

  const cargosAgencia = ["Gerente", "Director", "Supervisor", "Planificador", "Asistente"];
  const cargosCliente = [
    "Director de marketing",
    "Gerente de marketing",
    "Subgerente de marketing",
    "Brand manager",
    "Jefe de medios",
    "Asistente de marketing",
  ];

  const getCargoOptions = () => {
    if (newUser.rol === "agencia") return cargosAgencia;
    if (newUser.rol === "cliente") return cargosCliente;
    return [];
  };

  const getCargoOptionsForEdit = (rolParam) => {
    if (rolParam === "agencia") return cargosAgencia;
    if (rolParam === "cliente") return cargosCliente;
    return [];
  };

  const getClienteFilterOptions = () =>
    clientes
      .map((cliente) => ({
        value: cliente.id.toString(),
        label: cliente.empresa === cliente.producto ? cliente.nombre : `${cliente.empresa} | ${cliente.producto}`,
        sortKey: (cliente.empresa === cliente.producto ? cliente.nombre : cliente.empresa).toLowerCase(),
      }))
      .sort((a, b) => a.sortKey.localeCompare(b.sortKey, "es"));

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let processedValue = value;
    if (name === "nombre" || name === "apellido") {
      processedValue = capitalizeFirstLetter(value.trimEnd());
    } else if (name === "email") {
      processedValue = value.toLowerCase();
      setEmailError("");
    }
    setNewUser((prevUser) => ({
      ...prevUser,
      [name]: processedValue,
      ...(name === "rol" && value === "cliente" ? { entidad: "", edificiosOk: "", cargo: "" } : {}),
      ...(name === "rol" && value === "agencia" ? { entidad: "", edificiosOk: "", cargo: "" } : {}),
      ...(name === "rol" && value === "edificio" ? { entidad: "", cargo: "" } : {}),
    }));
    if (name === "rol") {
      setShowListaEdificios(value === "edificio");
    }
  };

  const handleAddUser = async (e) => {
    e.preventDefault();
    const edificiosSeleccionados = methods.getValues("edificiosSeleccionados");

    const paisCode = paisMap[pais] || "";
    const emailExists = usuarios.some(
      (usuario) => usuario.email?.toLowerCase() === newUser.email.toLowerCase() && usuario.pais === paisCode
    );
    if (emailExists) {
      setEmailError("Este correo ya está registrado");
      toast.error("Este correo ya está registrado");
      return;
    }

    if ((newUser.rol === "agencia" || newUser.rol === "cliente") && !newUser.entidad) {
      toast.error(`Debe seleccionar un ${newUser.rol === "agencia" ? "intermediario" : "cliente"}`);
      return;
    }

    if ((newUser.rol === "agencia" || newUser.rol === "cliente") && !newUser.cargo) {
      toast.error("Debe seleccionar un cargo");
      return;
    }

    if (newUser.rol === "agencia" && newUser.cargo && !cargosAgencia.includes(newUser.cargo)) {
      toast.error("Cargo inválido para el rol Agencia");
      return;
    }
    if (newUser.rol === "cliente" && newUser.cargo && !cargosCliente.includes(newUser.cargo)) {
      toast.error("Cargo inválido para el rol Cliente");
      return;
    }

    const userWithCountryAndIntermediary = {
      nombre: newUser.nombre,
      apellido: newUser.apellido,
      email: newUser.email,
      rol: newUser.rol,
      pais: paisMap[pais] || "",
      edificiosOk: newUser.rol === "edificio" ? edificiosSeleccionados : null,
      agencia: newUser.rol === "agencia" ? parseInt(newUser.entidad, 10) : null,
      cliente_id: newUser.rol === "cliente" ? parseInt(newUser.entidad, 10) : null,
      cargo: newUser.cargo || null,
      cargo_detalle: newUser.cargo_detalle || null,
    };

    try {
      const data = await saveUsuario(userWithCountryAndIntermediary);
      if (Array.isArray(data)) {
        setUsuarios([...usuarios, ...data]);
      } else if (data) {
        setUsuarios([...usuarios, data]);
      }
      setNewUser({
        nombre: "",
        apellido: "",
        email: "",
        rol: "",
        edificiosOk: "",
        entidad: "",
        cargo: "",
        cargo_detalle: "",
      });
      setEmailError("");
      setShowModal(false);
      setShowListaEdificios(false);
      toast.success("Usuario agregado correctamente");
    } catch (error) {
      console.error("Error al agregar usuario:", error);
      toast.error("Error al agregar usuario");
    }
  };

  const handleExportEmails = () => {
    try {
      const usuariosExportar = sortedUsuarios.filter(
        (u) =>
          (selectedRoles.agencia && u.rol === "agencia") ||
          (selectedRoles.cliente && u.rol === "cliente") ||
          (selectedRoles.edificio && u.rol === "edificio")
      );

      const correos = usuariosExportar
        .map((u) => u.email?.trim().toLowerCase())
        .filter((email) => email && email.includes("@") && email.includes("."));

      const correosUnicos = [...new Set(correos)];

      if (correosUnicos.length === 0) {
        toast.error("No hay correos válidos para exportar");
        return;
      }

      const roles = Object.keys(selectedRoles)
        .filter((key) => selectedRoles[key])
        .join("-");
      const filename = `correos-${roles}-${paisMap[pais] || "desconocido"}.txt`;
      const blob = new Blob([correosUnicos.join(", ")], { type: "text/plain;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      toast.success(`Exportados ${correosUnicos.length} correo(s)`);
    } catch (error) {
      console.error("Error exportando:", error);
      toast.error("Error al exportar");
    }
  };

  const handleOpenModal = () => {
    setNewUser({
      nombre: "",
      apellido: "",
      email: "",
      rol: "",
      edificiosOk: "",
      entidad: "",
      cargo: "",
    });
    setEmailError("");
    setShowListaEdificios(false);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowListaEdificios(false);
    setEmailError("");
  };

  const filtersContent = (
    <div className={styles.filtersContainer}>
      <input
        type="text"
        placeholder="Nombre"
        value={searchNombre}
        onChange={(e) => setSearchNombre(e.target.value)}
        className={searchNombre ? styles.activeFilter : ""}
      />
      <input
        type="text"
        placeholder="Apellido"
        value={searchApellido}
        onChange={(e) => setSearchApellido(e.target.value)}
        className={searchApellido ? styles.activeFilter : ""}
      />
      <AgenciasDropdown
        value={searchAgencia}
        onChange={(e) => setSearchAgencia(e.target.value)}
        intermediarios={intermediarios}
        placeholder="Agencia"
        className={`form-control ${searchAgencia ? styles.activeFilter : ""}`}
      />
      <select
        value={searchCliente}
        onChange={(e) => setSearchCliente(e.target.value)}
        className={searchCliente ? styles.activeFilter : ""}
      >
        <option value="">Cliente</option>
        {getClienteFilterOptions().map((option, index) => (
          <option key={`filter-cl-${option.value}-${index}`} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <select
        value={searchCargo}
        onChange={(e) => setSearchCargo(e.target.value)}
        className={searchCargo ? styles.activeFilter : ""}
      >
        <option value="">Cargo</option>
        <optgroup label="Agencia">
          {cargosAgencia.map((cargo, index) => (
            <option key={`cargo-ag-${index}`} value={cargo}>
              {cargo}
            </option>
          ))}
        </optgroup>
        <optgroup label="Cliente">
          {cargosCliente.map((cargo, index) => (
            <option key={`cargo-cl-${index}`} value={cargo}>
              {cargo}
            </option>
          ))}
        </optgroup>
      </select>
      <input
        type="text"
        placeholder="Correo"
        value={searchCorreo}
        onChange={(e) => setSearchCorreo(e.target.value)}
        className={searchCorreo ? styles.activeFilter : ""}
      />
      <select
        value={filtroRol}
        onChange={(e) => setFiltroRol(e.target.value)}
        className={filtroRol ? styles.activeFilter : ""}
      >
        <option value="">Todos los roles</option>
        {Object.values(ROLES).map((rolValue) => (
          <option key={`filtro-rol-${rolValue}`} value={rolValue}>
            {rolValue.charAt(0).toUpperCase() + rolValue.slice(1)}
          </option>
        ))}
      </select>
      {puedeEditar && (
        <div className={`dropdown ${styles.exportDropdown}`}>
          <button
            className="btn btn-outline-secondary dropdown-toggle"
            type="button"
            id="exportDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Exportar
          </button>
          <ul className={`dropdown-menu ${styles.exportMenu}`} aria-labelledby="exportDropdown">
            <li className={styles.exportItem}>
              <input
                type="checkbox"
                id="check-agencia"
                checked={selectedRoles.agencia}
                onChange={(e) => setSelectedRoles((prev) => ({ ...prev, agencia: e.target.checked }))}
              />
              <label htmlFor="check-agencia">Agencia</label>
            </li>
            <li className={styles.exportItem}>
              <input
                type="checkbox"
                id="check-cliente"
                checked={selectedRoles.cliente}
                onChange={(e) => setSelectedRoles((prev) => ({ ...prev, cliente: e.target.checked }))}
              />
              <label htmlFor="check-cliente">Cliente</label>
            </li>
            <li className={styles.exportItem}>
              <input
                type="checkbox"
                id="check-edificio"
                checked={selectedRoles.edificio}
                onChange={(e) => setSelectedRoles((prev) => ({ ...prev, edificio: e.target.checked }))}
              />
              <label htmlFor="check-edificio">Edificio</label>
            </li>
            <li className={styles.exportBtnContainer}>
              <button
                className="btn btn-secondary btn-sm"
                onClick={handleExportEmails}
                disabled={!selectedRoles.agencia && !selectedRoles.cliente && !selectedRoles.edificio}
              >
                Exportar
              </button>
            </li>
          </ul>
        </div>
      )}
      {puedeEditar && (
        <button type="button" className="btn btn-primary" onClick={handleOpenModal}>
          + Agregar
        </button>
      )}
    </div>
  );

  return (
    <div className={styles.containerUsuarios}>
      <Header expandChildren>{filtersContent}</Header>

      <div className={styles.usuariosTable}>
        <table
          className="table table-bordered table-hover align-middle"
          style={{ tableLayout: "fixed", width: "100%" }}
        >
          <thead className="table-dark text-center align-middle">
            <tr>
              <th className={styles.colNombre} onClick={() => handleSort("nombre")} style={{ cursor: "pointer" }}>
                Nombre {sortColumn === "nombre" && (sortDirection === "asc" ? "↑" : "↓")}
              </th>
              <th className={styles.colApellido} onClick={() => handleSort("apellido")} style={{ cursor: "pointer" }}>
                Apellido {sortColumn === "apellido" && (sortDirection === "asc" ? "↑" : "↓")}
              </th>
              <th className={styles.colRol} onClick={() => handleSort("rol")} style={{ cursor: "pointer" }}>
                Rol {sortColumn === "rol" && (sortDirection === "asc" ? "↑" : "↓")}
              </th>
              <th className={styles.colAgencia} onClick={() => handleSort("agencia")} style={{ cursor: "pointer" }}>
                Agencia o Cliente {sortColumn === "agencia" && (sortDirection === "asc" ? "↑" : "↓")}
              </th>
              <th className={styles.colCargo} onClick={() => handleSort("cargo")} style={{ cursor: "pointer" }}>
                Cargo {sortColumn === "cargo" && (sortDirection === "asc" ? "↑" : "↓")}
              </th>
              <th className={styles.colCorreo} onClick={() => handleSort("email")} style={{ cursor: "pointer" }}>
                Correo {sortColumn === "email" && (sortDirection === "asc" ? "↑" : "↓")}
              </th>
              <th className={styles.colTelefono}>Teléfono</th>
              <th className={styles.colCumpleanos}>Cumple</th>
              <th className={styles.colEstado}>Acceso</th>
              <th className={styles.colEdit}>Edit</th>
            </tr>
          </thead>
          <tbody>
            {sortedUsuarios.map((usuario) => (
              <tr key={usuario.id} className={usuario.habilitado === false ? styles.filaSuspendido : ""}>
                <td className={styles.colNombre}>
                  {isEditing && editingUser?.id === usuario.id && esAdmin ? (
                    <input
                      type="text"
                      value={editingUser.nombre || ""}
                      onChange={(e) => setEditingUser({ ...editingUser, nombre: e.target.value })}
                      onBlur={(e) =>
                        setEditingUser({ ...editingUser, nombre: capitalizeFirstLetter(e.target.value.trim()) })
                      }
                      className="form-control"
                      style={{ width: "100%", fontSize: "14px", margin: 0 }}
                    />
                  ) : (
                    usuario.nombre
                  )}
                </td>
                <td className={styles.colApellido}>
                  {isEditing && editingUser?.id === usuario.id && esAdmin ? (
                    <input
                      type="text"
                      value={editingUser.apellido || ""}
                      onChange={(e) => setEditingUser({ ...editingUser, apellido: e.target.value })}
                      onBlur={(e) =>
                        setEditingUser({ ...editingUser, apellido: capitalizeFirstLetter(e.target.value.trim()) })
                      }
                      className="form-control"
                      style={{ width: "100%", fontSize: "14px", margin: 0 }}
                    />
                  ) : (
                    usuario.apellido
                  )}
                </td>
                <td className={styles.colRol}>
                  {isEditing && editingUser?.id === usuario.id && esAdmin ? (
                    <select
                      value={editingUser.rol || ""}
                      onChange={(e) => {
                        setEditingUser({ ...editingUser, rol: e.target.value, entidad: "", cargo: "" });
                      }}
                      className="form-control"
                      style={{ width: "100%", fontSize: "14px", margin: 0 }}
                    >
                      <option value={ROLES.ADMINISTRATIVO}>Administrativo</option>
                      <option value={ROLES.AGENCIA}>Agencia</option>
                      <option value={ROLES.BOARD}>Board</option>
                      <option value={ROLES.BROKER}>Broker</option>
                      <option value={ROLES.CLIENTE}>Cliente</option>
                      <option value={ROLES.COMERCIAL}>Comercial</option>
                      <option value={ROLES.CONTABLE}>Contable</option>
                      <option value={ROLES.EDIFICIO}>Edificio</option>
                      <option value={ROLES.GERENCIA}>Gerencia</option>
                      <option value={ROLES.INFRAESTRUCTURA}>Infraestructura</option>
                      <option value={ROLES.INVERSOR}>Inversor</option>
                      <option value={ROLES.SUPERADMIN}>Superadmin</option>
                    </select>
                  ) : (
                    usuario.rol?.charAt(0).toUpperCase() + usuario.rol?.slice(1)
                  )}
                </td>
                <td className={styles.colAgencia}>
                  {isEditing && editingUser && editingUser.id === usuario.id ? (
                    <select
                      value={editingUser.entidad || ""}
                      onChange={handleEntidadChange}
                      className="form-control"
                      style={{
                        width: "80%",
                        fontSize: "14px",
                        textAlign: "start",
                        margin: "0",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                      disabled={editingUser.rol !== "agencia" && editingUser.rol !== "cliente"}
                    >
                      <option value="">
                        Seleccionar {editingUser.rol === "agencia" ? "Intermediario" : "Cliente"}
                      </option>
                      {(editingUser.rol === "agencia"
                        ? intermediarios.map((intermediario) => ({
                            value: intermediario.id,
                            label: intermediario.nombre,
                            keyPrefix: "agencia",
                          }))
                        : editingUser.rol === "cliente"
                          ? clientes.map((cliente) => ({
                              value: cliente.id,
                              label: cliente.producto,
                              keyPrefix: "cliente",
                            }))
                          : []
                      ).map((option) => (
                        <option key={`${option.keyPrefix}-${option.value}`} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>
                      {usuario.rol === "cliente"
                        ? (() => {
                            const cliente = clientes.find((c) => c.id === usuario.cliente_id);
                            return cliente
                              ? cliente.empresa === cliente.producto
                                ? cliente.nombre
                                : `${cliente.empresa} | ${cliente.producto}`
                              : "-";
                          })()
                        : usuario.rol === "agencia"
                          ? intermediarios.find((i) => i.id === usuario.agencia)?.nombre || "-"
                          : "-"}
                    </span>
                  )}
                </td>
                <td className={styles.colCargo}>
                  {isEditing && editingUser && editingUser.id === usuario.id ? (
                    <>
                      <select
                        value={editingUser.cargo || ""}
                        onChange={handleCargoChange}
                        className="form-control"
                        style={{
                          width: "80%",
                          fontSize: "14px",
                          textAlign: "start",
                          margin: "0",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        disabled={editingUser.rol !== "agencia" && editingUser.rol !== "cliente"}
                      >
                        <option value="">Seleccionar Cargo</option>
                        {getCargoOptionsForEdit(editingUser.rol).map((cargo, index) => (
                          <option key={`cargo-${index}`} value={cargo}>
                            {cargo}
                          </option>
                        ))}
                      </select>
                      {(editingUser.rol === "agencia" || editingUser.rol === "cliente") && (
                        <input
                          type="text"
                          placeholder="Detalle cargo"
                          value={editingUser.cargo_detalle || ""}
                          onChange={handleCargoDetalleChange}
                          className="form-control mt-1"
                          style={{ width: "80%", fontSize: "12px" }}
                        />
                      )}
                    </>
                  ) : (
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>
                      {usuario.cargo || "-"}
                      {usuario.cargo_detalle && (
                        <span style={{ display: "block", fontSize: ".7rem", color: "#666" }}>
                          {usuario.cargo_detalle}
                        </span>
                      )}
                    </span>
                  )}
                </td>
                <td className={styles.colCorreo}>
                  {isEditing && editingUser && editingUser.id === usuario.id ? (
                    <div>
                      <input
                        type="email"
                        value={editingUser.email}
                        onChange={handleEmailChange}
                        className="form-control"
                        style={{
                          width: "80%",
                          fontSize: "14px",
                          textAlign: "left",
                          margin: "0",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      />
                      {emailError && <small className="text-danger">{emailError}</small>}
                    </div>
                  ) : (
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>
                      {usuario.email.toLowerCase()}
                    </span>
                  )}
                </td>
                <td className={styles.colTelefono}>
                  {isEditing && editingUser?.id === usuario.id ? (
                    <input
                      type="tel"
                      value={editingUser.telefono || ""}
                      onChange={handleTelefonoChange}
                      placeholder={editingUser.pais === "PER" ? "+51 9XX XXX XXX" : "+56 9 XXXX XXXX"}
                      className="form-control"
                      style={{ width: "100%", fontSize: "14px", margin: 0 }}
                    />
                  ) : (
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>
                      {usuario.telefono || "-"}
                    </span>
                  )}
                </td>
                <td className={styles.colCumpleanos}>
                  {isEditing && editingUser?.id === usuario.id ? (
                    <input
                      type="date"
                      value={editingUser.fecha_nacimiento || ""}
                      onChange={(e) => setEditingUser({ ...editingUser, fecha_nacimiento: e.target.value })}
                      className="form-control"
                      style={{ width: "100%", fontSize: "12px", margin: 0 }}
                    />
                  ) : (
                    <span>
                      {usuario.fecha_nacimiento
                        ? new Date(usuario.fecha_nacimiento + "T12:00:00").toLocaleDateString("es-CL", {
                            day: "numeric",
                            month: "short",
                          })
                        : "-"}
                    </span>
                  )}
                </td>
                <td className={styles.colEstado}>
                  {usuario.habilitado === false ? (
                    <span className={`${styles.estadoBadge} ${styles.estadoSuspendido}`}>Anulado</span>
                  ) : (
                    <span className={`${styles.estadoBadge} ${styles.estadoActivo}`}>Activo</span>
                  )}
                </td>
                <td className={styles.colEdit}>
                  {puedeEditar ? (
                    isEditing && editingUser && editingUser.id === usuario.id ? (
                      <div style={{ display: "flex", gap: 12, justifyContent: "center", alignItems: "center" }}>
                        <FiSave
                          onClick={handleSaveClick}
                          style={{ cursor: "pointer", fontSize: "1.15rem" }}
                          title="Guardar"
                        />
                        {puedeSetearPassword && (
                          <FaKey
                            onClick={() => handleSetPassword(usuario)}
                            style={{ cursor: "pointer", fontSize: "1rem" }}
                            title="Asignar contraseña"
                          />
                        )}
                        {esAdmin &&
                          (usuario.habilitado === false ? (
                            <FaUndo
                              onClick={() => handleToggleHabilitado(usuario)}
                              style={{ cursor: "pointer", fontSize: "1rem", color: "#1e7e34" }}
                              title="Reactivar acceso"
                            />
                          ) : (
                            <FaBan
                              onClick={() => handleToggleHabilitado(usuario)}
                              style={{ cursor: "pointer", fontSize: "1rem", color: "#b02a37" }}
                              title="Anular acceso"
                            />
                          ))}
                        {esAdmin && (
                          <FaTrash
                            onClick={() => handleDeleteClick(usuario)}
                            style={{ cursor: "pointer", fontSize: "1rem", color: "#dc3545" }}
                            title="Eliminar definitivamente"
                          />
                        )}
                      </div>
                    ) : (
                      <FaEdit
                        onClick={() => handleEditClick(usuario)}
                        style={{ cursor: "pointer", fontSize: "1.15rem" }}
                        title="Editar usuario"
                      />
                    )
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {passwordModal.show && (
        <div className={styles.modalOverlay} onClick={() => setPasswordModal({ show: false, usuario: null })}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()} style={{ maxWidth: 400 }}>
            <div className={styles.modalHeader}>
              <h3>Asignar contraseña</h3>
              <button onClick={() => setPasswordModal({ show: false, usuario: null })}>&times;</button>
            </div>
            <div className={styles.modalBody}>
              <p style={{ marginBottom: 12 }}>
                {passwordModal.usuario?.nombre} {passwordModal.usuario?.apellido}
                <br />
                <small style={{ color: "#888" }}>{passwordModal.usuario?.email}</small>
              </p>
              <div className={styles.formGroup}>
                <label htmlFor="passwordInput">Contraseña</label>
                <input
                  type="text"
                  className="form-control"
                  id="passwordInput"
                  value={passwordInput}
                  onChange={(e) => setPasswordInput(e.target.value)}
                  placeholder="Mínimo 6 caracteres"
                  autoFocus
                  onKeyDown={(e) => e.key === "Enter" && handleConfirmPassword()}
                />
              </div>
            </div>
            <div className={styles.modalFooter}>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setPasswordModal({ show: false, usuario: null })}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleConfirmPassword}
                disabled={passwordInput.length < 6}
              >
                Asignar
              </button>
            </div>
          </div>
        </div>
      )}

      {showModal && (
        <div className={styles.modalOverlay} onClick={handleCloseModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h3>Agregar Usuario</h3>
              <button onClick={handleCloseModal}>&times;</button>
            </div>
            <FormProvider {...methods}>
              <form onSubmit={handleAddUser}>
                <div className={styles.modalBody}>
                  <div className={styles.formGroup}>
                    <label htmlFor="nombre">Nombre</label>
                    <input
                      type="text"
                      className="form-control"
                      id="nombre"
                      name="nombre"
                      value={newUser.nombre}
                      onChange={(e) => {
                        const trimmedValue = e.target.value.trimEnd();
                        handleInputChange({ target: { name: "nombre", value: trimmedValue } });
                      }}
                      onBlur={(e) => {
                        const trimmedValue = capitalizeFirstLetter(e.target.value.trimEnd());
                        handleInputChange({ target: { name: "nombre", value: trimmedValue } });
                      }}
                      required
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label htmlFor="apellido">Apellido</label>
                    <input
                      type="text"
                      className="form-control"
                      id="apellido"
                      name="apellido"
                      value={newUser.apellido}
                      onChange={(e) => {
                        const trimmedValue = e.target.value.trimEnd();
                        handleInputChange({ target: { name: "apellido", value: trimmedValue } });
                      }}
                      onBlur={(e) => {
                        const trimmedValue = capitalizeFirstLetter(e.target.value.trimEnd());
                        handleInputChange({ target: { name: "apellido", value: trimmedValue } });
                      }}
                      required
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label htmlFor="email">Correo</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      value={newUser.email}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (!value.trim().endsWith(" ")) {
                          handleInputChange({ target: { name: "email", value: value } });
                        }
                      }}
                      onBlur={(e) => {
                        const trimmedValue = e.target.value.trimEnd();
                        if (trimmedValue !== e.target.value) {
                          handleInputChange({ target: { name: "email", value: trimmedValue } });
                        }
                      }}
                      required
                    />
                    {emailError && <small className="text-danger">{emailError}</small>}
                  </div>
                  <div className={styles.formGroup}>
                    <label htmlFor="rol">Rol</label>
                    <select
                      className="form-control"
                      id="rol"
                      name="rol"
                      value={newUser.rol}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="" disabled>
                        Seleccionar Rol
                      </option>
                      {puedeVerTodosLosRoles ? (
                        <>
                          <option value={ROLES.ADMINISTRATIVO}>Administrativo</option>
                          <option value={ROLES.AGENCIA}>Agencia</option>
                          <option value={ROLES.BOARD}>Board</option>
                          <option value={ROLES.BROKER}>Broker</option>
                          <option value={ROLES.CLIENTE}>Cliente</option>
                          <option value={ROLES.COMERCIAL}>Comercial</option>
                          <option value={ROLES.CONTABLE}>Contable</option>
                          <option value={ROLES.EDIFICIO}>Edificio</option>
                          <option value={ROLES.GERENCIA}>Gerencia</option>
                          <option value={ROLES.INFRAESTRUCTURA}>Infraestructura</option>
                          <option value={ROLES.INVERSOR}>Inversor</option>
                          <option value={ROLES.SUPERADMIN}>Superadmin</option>
                        </>
                      ) : (
                        <>
                          <option value="agencia">Agencia</option>
                          {rol !== "comercial" && <option value="edificio">Edificio</option>}
                          <option value="cliente">Cliente</option>
                        </>
                      )}
                    </select>
                  </div>
                  {(newUser.rol === "agencia" || newUser.rol === "cliente") && (
                    <>
                      <div className={styles.formGroup}>
                        <label htmlFor="entidad">{newUser.rol === "agencia" ? "Intermediario" : "Cliente"}</label>
                        <select
                          className="form-control"
                          id="entidad"
                          name="entidad"
                          value={newUser.entidad}
                          onChange={handleInputChange}
                        >
                          <option value="">
                            {newUser.rol === "agencia" ? "Seleccionar Intermediario" : "Seleccionar Cliente"}
                          </option>
                          {getEntidadOptions().map((option, index) => (
                            <option key={`${newUser.rol}-${option.value}-${index}`} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className={styles.formGroup}>
                        <label htmlFor="cargo">Cargo</label>
                        <select
                          className="form-control"
                          id="cargo"
                          name="cargo"
                          value={newUser.cargo}
                          onChange={handleInputChange}
                        >
                          <option value="">Seleccionar Cargo</option>
                          {getCargoOptions().map((cargo, index) => (
                            <option key={`new-cargo-${index}`} value={cargo}>
                              {cargo}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className={styles.formGroup}>
                        <label htmlFor="cargo_detalle">Detalle cargo</label>
                        <input
                          type="text"
                          className="form-control"
                          id="cargo_detalle"
                          name="cargo_detalle"
                          placeholder="Ej: Managing Director, Cross Media Planner..."
                          value={newUser.cargo_detalle || ""}
                          onChange={handleInputChange}
                        />
                      </div>
                    </>
                  )}
                  {showListaEdificios && (
                    <div className="mt-3">
                      <ListaEdificios
                        forceSubmit={() => {
                          const edificiosSeleccionados = methods.getValues("edificiosSeleccionados");
                          setNewUser((prevState) => ({
                            ...prevState,
                            edificiosOk: edificiosSeleccionados,
                          }));
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className={styles.modalFooter}>
                  <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                    Cancelar
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Agregar Usuario
                  </button>
                </div>
              </form>
            </FormProvider>
          </div>
        </div>
      )}
    </div>
  );
};
